import axios from "axios";
const BaseURL = process.env.REACT_APP_API_PATH;

export const GetCurrency = async () => {
  const res = await axios.get(`${BaseURL}/ebench/get_all_currencies`);
    return res.data; // return only needed data
};



